import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  const items = t("marquee");
  return (
    <div
      className="border-y border-border bg-foreground text-background py-4 select-none"
      data-testid="editorial-marquee"
    >
      <Marquee speed={26} gradient={false}>
        {items.concat(items).map((txt, i) => (
          <span
            key={i}
            className="font-mono text-sm md:text-base tracking-[0.25em] uppercase mx-8 inline-flex items-center gap-8"
          >
            {txt}
            <span className="text-accent">/ /</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
